/* eslint-disable no-restricted-syntax */

import React from 'react';

import PropTypes from 'prop-types';

import { sharing, storageKeys } from 'settings';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { APIHandler, DataHandler, StorageHandler, PointsHandler } from 'C4';

const names = {
  mail: 'email',
  facebook: 'fb',
  twitter: 'twitter',
  download: 'download',
};

const copyFunction = (str) => {
  const area = document.createElement('textarea');
  area.value = str;
  area.setAttribute('readonly', '');
  area.style.position = 'fixed';
  area.style.left = '-1000rem';
  document.body.appendChild(area);
  area.focus();
  area.select();
  document.execCommand('copy');

  if (document.body.contains(area)) {
    document.body.removeChild(area);
  }
};

const shareAnalytics = (name, profileId, value) => {
  DataHandler.matchAppId().then((appId) => {
    StorageHandler.load(storageKeys.user).then((userObj) => {
      let email = '';
      ({ email } = userObj.response);
      if (profileId !== 0) {
        APIHandler.trackEvent(appId, profileId, email, 'profile', name, value);
      } else {
        APIHandler.trackEvent(appId, email, 'xpopro', name, value).then(() => {});
      }
    });
  });
};

const Sharing = (props) => {
  const { triggerId, withText, hideDownload, profileId } = props;

  let { url } = props;
  const internalURL = url.length > 0 ? url.match(/[0-9]{3}.*?$/g) : '';
  const parsedURL = `${window.location.origin}/?file=${url}`;

  // Creates a download url based on app_id, if above 499 use the new developer tool
  let urlEncoded = url.length > 0 ? parsedURL.replace(/ /g, '%20') : '';
  urlEncoded = urlEncoded.replace('https://', 'https://share.');
  urlEncoded = urlEncoded.replace('http://', 'http://share.');

  if (urlEncoded.includes('exhibition')) {
    url = urlEncoded;
  }

  // Image // Infographic (pdf or png) // Video
  const extension = url.substring(url.lastIndexOf('.') + 1);
  let shareSubject = sharing.imageEmailSubject;
  let shareCopy = sharing.imageEmailCopy;

  if (extension === 'pdf' || extension === 'png') {
    shareSubject = sharing.infographicEmailSubject;
    shareCopy = sharing.infographicEmailCopy;
  } else if (extension === 'mp4') {
    shareSubject = sharing.videoEmailSubject;
    shareCopy = sharing.videoEmailCopy;
  } else if (url.includes('exhibition')) {
    shareSubject = sharing.companyProfileEmailSubject;
    shareCopy = sharing.companyProfileEmailCopy;
  }

  const hide = { display: triggerId ? 'none' : 'inline-block' };

  const onClickEvent = async (button) => {
    const appId = await DataHandler.matchAppId();
    const {
      response: { email },
    } = await StorageHandler.load('user');
    const name = names[button.querySelector('span').innerHTML.toLowerCase()];
    await APIHandler.trackEvent(appId, email, name === 'download' ? 'downloads' : 'shares', name, button.href);
  };

  if (!window.observers) window.observers = {};

  if (!window.observers[url]) {
    window.observers[url] = new MutationObserver(async (list, observer) => {
      for (const mutation of list) {
        if (mutation.target.querySelector('.sharing')) {
          const element = document.querySelector('.sharing');
          const input = element.querySelector('#shareURL');
          input.onclick = async ({ target }) => {
            /* eslint-disable no-param-reassign */
            target.innerText = 'Copied';
            copyFunction(target.value);
            setTimeout(() => {
              target.innerText = 'Copy Link';
            }, 2000);
            /* eslint-enable no-param-reassign */
          };

          const { children: wrapper } = document.querySelector('.wrapper__paragraph');
          Array.from(wrapper).forEach((button, i) => {
            wrapper[i].onclick = () => onClickEvent(button);
          });

          observer.disconnect();
          window.observers[url] = null;
        }
      }
    });
    window.observers[url].observe(document.body, { childList: true });
  }

  return (
    <div className="sharing" id={triggerId || null} style={hide}>
      <p className="wrapper__paragraph">
        <a
          href={`https://www.facebook.com/sharer/sharer.php?u=${url}`}
          className="fancybox-share__button fancybox-share__button--fb"
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => shareAnalytics('booth-share-facebook', profileId, url)}
        >
          <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
            <path d="m287 456v-299c0-21 6-35 35-35h38v-63c-7-1-29-3-55-3-54 0-91 33-91 94v306m143-254h-205v72h196" />
          </svg>
          {withText && <span>Facebook</span>}
        </a>
        <a
          href={`https://twitter.com/share?url=${url}&text=${sharing.twitter}`}
          className="fancybox-share__button fancybox-share__button--tw"
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => shareAnalytics('booth-share-twitter', profileId, url)}
        >
          <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
            <path
              d="m456 133c-14 7-31 11-47 13 17-10 30-27 37-46-15 10-34 16-52 20-61-62-157-7-141 75-68-3-129-35-169-85-22
              37-11 86 26 109-13 0-26-4-37-9 0 39 28 72 65 80-12 3-25 4-37 2 10 33 41 57 77 57-42 30-77 38-122 34 170 111 378-32
              359-208 16-11 30-25 41-42z"
            />
          </svg>
          {withText && <span>Twitter</span>}
        </a>
        <a
          href={`mailto:?subject=${shareSubject}&body=${shareCopy} ${url}`}
          className="fancybox-share__button fancybox-share__button--pt"
          onClick={() => shareAnalytics('booth-share-email', profileId, url)}
        >
          <FontAwesomeIcon icon={['far', 'at']} />
          {withText && <span>E-mail</span>}
        </a>
        {hideDownload !== true && (
          <a
            href={`https://stack.travpromobile.com/download.php?url=${url}`}
            className="fancybox-download__button fancybox-download__button--pt"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => shareAnalytics('booth-share-download', profileId, url)}
          >
            <FontAwesomeIcon icon={['far', 'download']} />
            {withText && <span>Download</span>}
          </a>
        )}
      </p>
      <p>
        <button
          id="shareURL"
          className="fancybox-share__input"
          type="button"
          value={url}
          onClick={() => shareAnalytics('booth-share-copy', profileId, url)}
        >
          Copy Link
        </button>
      </p>
    </div>
  );
};

export default Sharing;

Sharing.propTypes = {
  url: PropTypes.string.isRequired,
  hideDownload: PropTypes.bool,
  profileId: PropTypes.string,
};

Sharing.defaultProps = {
  hideDownload: false,
  profileId: 0,
};
